var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Department Grid")]),_c('ag-grid-vue',{staticClass:"ag-theme-balham default-grid",attrs:{"column-defs":_vm.departmentColumnDefs,"row-data":_vm.departmentRowData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }